export default "__VITE_ASSET__Crb7HO$e__"